import { ReactElement } from 'react'

export const data = [
  {
    id: 1,
    title: 'Raport Anual de Activitate Clinică și Administrativă',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 2,
    title: 'Analiza Performanței Personalului Medical și Non-Medical',
    report_type: 'Raportul de externare',
    department: 'Departamente administrative',
    date: '02-11-2020'
  },
  {
    id: 3,
    title: 'Raport de Calitate și Siguranță a Pacienților',
    report_type: 'Raportul de activitate',
    department: 'Departamente administrative',
    date: '02-11-2020'
  },
  {
    id: 4,
    title: 'Monitorizarea Infecțiilor Nosocomiale și Măsuri de Prevenție',
    report_type: 'Raportul financiar',
    department: 'Departamente administrative',
    date: '02-11-2020'
  },
  {
    id: 5,
    title: 'Title 5',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 6,
    title: 'Title 6',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 7,
    title: 'Title 7',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 8,
    title: 'Title 8',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 9,
    title: 'Title 9',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 10,
    title: 'Title 10',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 11,
    title: 'Title 11',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 12,
    title: 'Title 12',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 13,
    title: 'Title 13',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 14,
    title: 'Title 14',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 15,
    title: 'Title 15',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 16,
    title: 'Title 16',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 17,
    title: 'Title 17',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 18,
    title: 'Title 18',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 19,
    title: 'Title 19',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  },
  {
    id: 20,
    title: 'Title 20',
    report_type: 'Medical al pacientului',
    department: 'Departamente medicale',
    date: '02-11-2020'
  }
]

export const detailsTableData = [
  {
    id: 1,
    contract_date: '01/01/2024 - 1/303-80744/80482',
    type: 'Contract',
    product: '024562',
    group: 'Dezinfectanti',
    um: 'Flacon',
    contract_quantity: '0.00',
    contract_value: '0.00000',
    amount_purchase: '10.00000'
  },
  {
    id: 2,
    contract_date: '01/01/2024 - 1/303-80744/80482',
    type: 'Contract',
    product: '024562',
    group: 'Dezinfectanti',
    um: 'Flacon',
    contract_quantity: '1.00',
    contract_value: '0.00000',
    amount_purchase: '25.00000'
  },
  {
    id: 33,
    contract_date: '01/01/2024 - 1/303-80744/80482',
    type: 'Contract',
    product: '024562',
    group: 'Dezinfectanti',
    um: 'Flacon',
    contract_quantity: '60,000.00',
    contract_value: '0.00000',
    amount_purchase: '123.00000'
  },
  {
    id: 3,
    contract_date: '01/01/2024 - 1/303-80744/80482',
    type: 'Contract',
    product: '024562',
    group: 'Dezinfectanti',
    um: 'Flacon',
    contract_quantity: '0.00',
    contract_value: '0.00000',
    amount_purchase: '10.00000'
  },
  {
    id: 5,
    contract_date: '01/01/2024 - 1/303-80744/80482',
    type: 'Contract',
    product: '024562',
    group: 'Dezinfectanti',
    um: 'Flacon',
    contract_quantity: '1.00',
    contract_value: '0.00000',
    amount_purchase: '25.00000'
  },
  {
    id: 6,
    contract_date: '01/01/2024 - 1/303-80744/80482',
    type: 'Contract',
    product: '024562',
    group: 'Dezinfectanti',
    um: 'Flacon',
    contract_quantity: '60,000.00',
    contract_value: '0.00000',
    amount_purchase: '123.00000'
  },
  {
    id: 7,
    contract_date: '01/01/2024 - 1/303-80744/80482',
    type: 'Contract',
    product: '024562',
    group: 'Dezinfectanti',
    um: 'Flacon',
    contract_quantity: '0.00',
    contract_value: '0.00000',
    amount_purchase: '10.00000'
  },
  {
    id: 8,
    contract_date: '01/01/2024 - 1/303-80744/80482',
    type: 'Contract',
    product: '024562',
    group: 'Dezinfectanti',
    um: 'Flacon',
    contract_quantity: '1.00',
    contract_value: '0.00000',
    amount_purchase: '25.00000'
  },
  {
    id: 9,
    contract_date: '01/01/2024 - 1/303-80744/80482',
    type: 'Contract',
    product: '024562',
    group: 'Dezinfectanti',
    um: 'Flacon',
    contract_quantity: '60,000.00',
    contract_value: '0.00000',
    amount_purchase: '123.00000'
  },
  {
    id: 10,
    contract_date: '01/01/2024 - 1/303-80744/80482',
    type: 'Contract',
    product: '024562',
    group: 'Dezinfectanti',
    um: 'Flacon',
    contract_quantity: '0.00',
    contract_value: '0.00000',
    amount_purchase: '10.00000'
  },
  {
    id: 11,
    contract_date: '01/01/2024 - 1/303-80744/80482',
    type: 'Contract',
    product: '024562',
    group: 'Dezinfectanti',
    um: 'Flacon',
    contract_quantity: '1.00',
    contract_value: '0.00000',
    amount_purchase: '25.00000'
  },
  {
    id: 12,
    contract_date: '01/01/2024 - 1/303-80744/80482',
    type: 'Contract',
    product: '024562',
    group: 'Dezinfectanti',
    um: 'Flacon',
    contract_quantity: '60,000.00',
    contract_value: '0.00000',
    amount_purchase: '123.00000'
  },
  {
    id: 13,
    contract_date: '01/01/2024 - 1/303-80744/80482',
    type: 'Contract',
    product: '024562',
    group: 'Dezinfectanti',
    um: 'Flacon',
    contract_quantity: '0.00',
    contract_value: '0.00000',
    amount_purchase: '10.00000'
  },
  {
    id: 14,
    contract_date: '01/01/2024 - 1/303-80744/80482',
    type: 'Contract',
    product: '024562',
    group: 'Dezinfectanti',
    um: 'Flacon',
    contract_quantity: '1.00',
    contract_value: '0.00000',
    amount_purchase: '25.00000'
  },
  {
    id: 15,
    contract_date: '01/01/2024 - 1/303-80744/80482',
    type: 'Contract',
    product: '024562',
    group: 'Dezinfectanti',
    um: 'Flacon',
    contract_quantity: '60,000.00',
    contract_value: '0.00000',
    amount_purchase: '123.00000'
  }
]

export type ReportTreeSelectDataType = {
  key: string
  label: string
  children?: ReportTreeSelectDataType[]
}

export type MenuItem = {
  label: ReactElement
  key: string
  children?: MenuItem[]
}

export const reportTreeSelectData = [
  {
    key: 'Republica Moldova',
    label: 'Republica Moldova',
    children: [
      {
        key: 'Bălți',
        label: 'Bălți',
        children: [
          {
            key: 'Instituție #1',
            label: 'Instituție #1'
          },
          {
            key: 'Instituție #2',
            label: 'Instituție #2'
          },
          {
            key: 'Instituție #3',
            label: 'Instituție #3'
          }
        ]
      },
      {
        key: 'mun. Chișinău',
        label: 'mun. Chișinău',
        children: [
          {
            key: 'Instituție #4',
            label: 'Instituție #4'
          }
        ]
      },
      {
        key: 'Călărași',
        label: 'Călărași',
        children: [
          {
            key: 'Instituție #5',
            label: 'Instituție #5'
          },
          {
            key: 'Instituție #6',
            label: 'Instituție #6'
          }
        ]
      },
      {
        key: 'Transnistria',
        label: 'Transnistria',
        children: [
          {
            key: 'Instituție #7',
            label: 'Instituție #7'
          },
          {
            key: 'Instituție #8',
            label: 'Instituție #8'
          }
        ]
      }
    ]
  }
]

export enum ReportFilesType {
  PDF = 'PDF',
  EXCEL = 'Excel'
}

export const reportDetailsFiltersData = [
  {
    id: 1,
    title: 'Tip',
    values: [
      { id: 1, value: 'Contract', label: 'Contract' },
      { id: 2, value: 'Contract2', label: 'Contract2' }
    ]
  },
  {
    id: 2,
    title: 'Produs',
    values: [
      { id: 1, value: '024562', label: '024562' },
      { id: 2, value: '024324', label: '024324' }
    ]
  },
  {
    id: 3,
    title: 'Grupa',
    values: [
      { id: 1, value: 'Dezinfectanti', label: 'Dezinfectanti' },
      { id: 2, value: 'Dezinfectanti2', label: 'Dezinfectanti2' }
    ]
  },
  {
    id: 4,
    title: 'UM',
    values: [
      { id: 1, value: 'Flacon', label: 'Flacon' },
      { id: 2, value: 'Flacon2', label: 'Flacon2' }
    ]
  },
  {
    id: 5,
    title: 'Cantitate contractata',
    values: [
      { id: 1, value: '0.00', label: '0.00' },
      { id: 2, value: '0.55', label: '0.55' }
    ]
  }
]
